import type { CurrencyCode } from '~/schemas/shopify/admin.types';

import { createPersistedStoreWithShopId } from '~/utils/createPersistedStore';
import { DEFAULT_CURRENCY_ANALYTIC } from '..';

export interface ICurrencyStoreState {
  currencyMode: CurrencyCode;
  setCurrencyMode: (currencyMode: CurrencyCode) => void;
}

export const useCurrencyStore = createPersistedStoreWithShopId<ICurrencyStoreState>(
  'currency',
  (set) => ({
    currencyMode: DEFAULT_CURRENCY_ANALYTIC,
    setCurrencyMode: (currencyMode) => set({ currencyMode }),
  }),
);
